var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 647.13 643.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3a8ef6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M646.77,82.49c.49,4.34.49,13.35,0,17.69-1.34,11.94-7.56,25.65-14.63,35.29l-293.68,295.1c-47.23,17.69-97.47,27.97-145.94,42.34-9.19,1.47-18.22-6.39-18.27-15.67l38.33-141.23,4.2-7.17L511.72,14.98c47.46-43.32,129.24,15.99,135.05,67.51ZM555.19,32.66c-19.24,0-33.5,14.87-44.75,28.8l76.15,75.28c23.23-19.46,39.72-44.81,17.19-72.54-11.58-14.25-29.21-31.55-48.59-31.54ZM485.97,85.15l-233.17,233.3,73.93,76.12,235.31-234.52-76.07-74.89ZM296.88,411.07l-60.62-60.65-22.74,83.41,83.36-22.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.3,408.99c8.63-8.64,24.72-4.27,27.3,7.85l.04,155.37c-4.39,37.58-33.82,67.02-71.3,71.47H73.88c-39.34-2.75-70.12-35.24-73.82-74l-.07-431c2.94-37.98,31.32-69.23,69.04-74.99l157.79-.21c17.24,5.08,17.24,26.48-.12,31.59-47.99,2.98-100.29-3.74-147.76.02-24.09,1.91-42.57,18.34-46.11,42.33l.05,433.56c3.42,19.26,17.36,34.74,36.36,39.45,154.14,3.78,308.9.49,463.27,1.66,28.52-2.14,46.49-20.18,48.63-48.66,3.51-46.86-2.7-98.1-.08-145.42.21-2.89,2.3-7.07,4.25-9.02Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b584679f4b98f3134a9a7c369660a35a.svg";
export { ForwardRef as ReactComponent };